import moment from 'moment'
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      interval: [
        { text: this.$gettext('Daily'), value: 'daily' },
        { text: this.$gettext('Weekly'), value: 'weekly' },
        { text: this.$gettext('Monthly'), value: 'monthly' },
      ],
      daily_options: [
        { text: this.$gettext('Mon'), value: "0" },
        { text: this.$gettext('Tue'), value: "1" },
        { text: this.$gettext('Wed'), value: "2" },
        { text: this.$gettext('Thu'), value: "3" },
        { text: this.$gettext('Fri'), value: "4" },
        { text: this.$gettext('Sat'), value: "5" },
        { text: this.$gettext('Sun'), value: "6" }
      ],
    }
  },
  computed: {
    ...mapGetters ({ 
      preferredLanguage: 'main/getPreferredLanguage'
    })
  },
  methods: {
    recurrencySummary (recurrent) {
      let sentence = this.$gettext('and afterwards, every %(freq) %(end_condition)')
      let freq = ''

      if (recurrent.interval === 'daily') {
        let days = this.$gettext('day') + ' '
        if (recurrent.days.length < 7) {
          const matching_days = this.daily_options.filter(option => recurrent.days.includes(option.value)).map(option => option.text)
          days = matching_days.join(', ')
        }
        freq = days
      } else if (recurrent.interval === 'weekly') {
        if (recurrent.skip === 1) {
          freq = this.$gettext("week")
        } else {
          freq = '%(interval) ' + this.$gettext("weeks")
        }
        freq = freq.replace('%(interval)', recurrent.skip)
      } else if (recurrent.interval === 'monthly') {
        if (recurrent.skip === 1) {
          freq = this.$gettext("month")
        } else {
          freq = '%(interval) ' + this.$gettext("months")
        }
        freq = freq.replace('%(interval)', recurrent.skip)
      }

      let end_condition = ''
      if (recurrent.end_method === 'iteration') {
        end_condition = this.$gettext('for %(iters) time(s)')
        end_condition = end_condition.replace('%(iters)', parseInt(recurrent.iterations) - 1)
      } else if (recurrent.end_method === 'date') {
        end_condition = this.$gettext('until %(end_date)')
        if (recurrent.end_date === 'string') {
          end_condition = end_condition.replace('%(end_date)', recurrent.end_date)
        } else {
          end_condition = end_condition.replace('%(end_date)', moment(new Date(recurrent.end_date)).format('DD-MM-YYYY'))
        }
      }

      sentence = sentence.replace('%(freq)', freq)
      return sentence.replace('%(end_condition)', end_condition)
    },
    nextDeliveryDate (recurrent) {
      let next_date
      if (recurrent.next_date) {
        next_date = moment(new Date(recurrent.next_date)).locale(this.preferredLanguage).format('dddd, MMMM Do, YYYY')
      } else {
        if (recurrent.start_date === Date.today().format('Y-m-d')) {
          next_date = this.$gettext('right now')
        } else {
          next_date = moment(new Date(recurrent.start_date)).locale(this.preferredLanguage).format('dddd, MMMM Do, YYYY')
        }
      }
      return next_date
    },
    createSummary (recurrent) {
      if (recurrent.interval === 'daily') {
        const matching_days = this.daily_options.filter(option => recurrent.days.includes(option.value)).map(option => option.text)
        var key1 = '', interval_value = ''
        if (matching_days.length == 7) {
          key1 = 'F11'
        } else {
          if (matching_days.length == 1) {
            key1 = 'F12'
            interval_value = matching_days
          } else {
            key1 = 'F12';
            var lastDay = matching_days.pop(matching_days.length-1);
            interval_value = matching_days.join(', ') + ' ' + this.$gettext("and") + ' ' + lastDay;
          }
        }
      } else if (recurrent.interval === 'weekly') {
        if (recurrent.skip == 1) {
          key1 = 'F21'
        } else {
          key1 = 'F22'
          interval_value = recurrent.skip
        }
      } else if (recurrent.interval === 'monthly') {
        if (recurrent.skip == 1) {
          key1 = 'F31'
        } else {
          key1 = 'F32'
          interval_value = recurrent.skip
        }
      }

      var key2='E1', end_value = '';
      if (recurrent.end_method === 'iteration') {
        if (recurrent.iterations == 1) {
          key2 = 'E2'
        } else {
          key2 = 'E3'
          end_value = recurrent.iterations
        }
      } else if (recurrent.end_method == 'date') {
        key2 = 'E4'
        end_value = recurrent.end_date
      }

      let sentence
      if (recurrent.start_date === Date.today().format('Y-m-d')) {
        sentence = this.$gettext("Send invoices every %(frequency)s %(end_method)s.") + ' ' + this.$gettext('First invoice will be sent manually and afterwards automatically every %(frequency)s') + " " + recurrent.next_delivery_message
      } else {
        sentence = this.$gettext("Send invoices every %(frequency)s %(end_method)s starting") + " " + recurrent.next_delivery_message
      }

      if (key2 == 'E2'){

        if (recurrent.start_date === Date.today().format('Y-m-d')) {
          sentence = this.$gettext("This invoice will be sent out only once") + ". " + this.$gettext("You will have to send it manually right now.")
        } else {
          sentence = this.$gettext("This invoice will be sent out only once") + " " + recurrent.next_delivery_message
        }

      }

      var interval = {
        "F11": this.$gettext("day"),
        "F12": this.$gettext("%(interval)s"),
        "F21": this.$gettext("week"),
        "F22": this.$gettext("%(interval)s weeks"),
        "F31": this.$gettext("month"),
        "F32": this.$gettext("%(interval)s months")
      }

      var end = {
        "E1": "",
        "E2": this.$gettext("once"),
        "E3": this.$gettext("%(end)s times"),
        "E4": this.$gettext("until %(end)s")
      }
      let summary = sentence.replaceAll("%(frequency)s", interval[key1].replaceAll("%(interval)s", interval_value)).replaceAll("%(end_method)s", end[key2].replaceAll("%(end)s", end_value))
      summary = summary.replace(' .', '.')
      this.$set(recurrent, 'summary', summary)
      return summary
    },
    prepareDataForSubmit (recurrent) {
      const recurrent_copy = JSON.parse(JSON.stringify(recurrent));

      recurrent_copy.company_profile = this.currentCompany.id

      if (recurrent.invoice && recurrent.invoice.id) {
        recurrent_copy.invoice = recurrent.invoice.id
      } 
      
      // else if (this.invoice) {
      //   recurrent_copy.invoice = this.invoice.id
      // }

      if (recurrent.interval === 'daily') {
        recurrent_copy.days = recurrent.days.join()
      } else {
        recurrent_copy.days = ''
      }

      let date_value
      date_value = Date.parse(recurrent_copy.start_date)
      if (date_value) {
        recurrent_copy.start_date = date_value.toString("yyyy-MM-dd")
      }
      date_value = Date.parse(recurrent_copy.end_date)
      if (date_value) {
        recurrent_copy.end_date = date_value.toString("yyyy-MM-dd")
      }
      return recurrent_copy
    },
  }
}